import applyFilters from "./applyfilter";
import changeOnScroll from "./changeOnScroll";
import jump from "./jump";
import checkIfOpen from "./checkIfOpen";

let selectHandler: EventListener = (event: Event) => {
    if (event.target instanceof HTMLElement) {
        let filterBlock = event.target?.closest('.wp-block-taxonomy-filter-filter');

        let field = filterBlock?.querySelector('.taxonomy-filter-field');

        if(field && field instanceof HTMLInputElement) {
            field.value = event.target.dataset.value??'';
        }

        let trigger = filterBlock?.querySelector('.taxonomy-filter-trigger');
        let parentBlock = event.target?.closest('.wp-block-taxonomy-filter-filtered-posts');
        
        if(trigger && 'innerHTML' in trigger) {
            trigger.innerHTML = event.target.innerHTML;
        }
     
        filterBlock?.classList.remove('open');

        if(parentBlock instanceof HTMLElement) {
            checkIfOpen(parentBlock);
        }

        let form = event.target?.closest('form');
        if(form != null) {
            let get = !(field?.classList.contains('jump-headings'));
            applyFilters(form,get).then(() => {
                jump(form as HTMLFormElement)
            });
        }
    }
}

let init = () => {
    let options = document.querySelectorAll('.taxonomy-filter-selector li');

    for(let option of options) {
        option.addEventListener('click',selectHandler);
    }

    let filterbar = document.querySelector('form.wp-block-taxonomy-filter-filterbar');
    if(filterbar instanceof HTMLFormElement) {
        jump(filterbar,true);
        changeOnScroll(filterbar);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

export {};